var ConfigTreejson = [
  {
    id: "1",
    label: "General",
    pagename: "General",
    children: [],
    child: [],
  },
  {
    id: "222",
    label: "Group",
    pagename: "GroupConfiguration",
    children: [],
    child: [
      {
        id: "21",
        label: "Group Configuration",
        pagename: "GroupConfiguration",
        children: [],
        child: [],
      },
    ],
  },
  {
    id: "2",
    label: "Alert",
    pagename: "AlertConfiguration",
    children: [],
    child: [
      {
        id: "20",
        label: "Alert Configuration",
        pagename: "AlertConfiguration",
        children: [],
        child: [],
      },
      {
        id: "21",
        label: "Alert General Configuration",
        pagename: "AlertGeneralConfiguration",
        children: [],
        child: [],
      },
    ],
  },
  {
    id: "3",
    label: "Report",
    pagename: "TemplateGroup",
    children: [],
    child: [
      {
        id: "22",
        label: "Template Group",
        pagename: "TemplateGroup",
        children: [],
        child: [],
      },
      {
        id: "23",
        label: "Template",
        pagename: "Template",
        children: [],
        child: [],
      },
      {
        id: "24",
        label: "Configuration",
        pagename: "TemplateConfigurator",
        children: [],
        child: [],
      },
      {
        id: "25",
        label: "Scheduler",
        pagename: "Scheduler",
        children: [],
        child: [],
      },
    ],
  },
  {
    id: "4",
    label: "System Setup",
    pagename: "SystemSetup",
    children: [],
    child: [],
  },
  {
    id: "5",
    label: "Organisation Setting",
    pagename: "OrganisationSetting",
    children: [],
    child: [],
  },
  {
    id: "6",
    label: "Modules",
    pagename: "ComplianceConfiguration",
    children: [],
    child: [
      {
        id: "14",
        label: "Energy Analytics",
        pagename: "EnergyAnalyticsConfiguration",
        children: [],
        child: [],
      },
      {
        id: "15",
        label: "Energy Accounting",
        pagename: "EnergyAccountingConfiguration",
        children: [],
        child: [],
      },
      {
        id: "16",
        label: "Power Quality",
        pagename: "PowerQualityConfiguration",
        children: [],
        child: [],
      },
      {
        id: "35",
        label: "Periodic Maintenance Configuration Parameters",
        pagename: "PeriodicMaintenanceConfigurationParameters",
        children: [],
        child: [],
      },
      {
        id: "36",
        label: "Periodic Maintenance Schedule",
        pagename: "PeriodicMaintenanceSchedule",
        children: [],
        child: [],
      },
      {
        id: "13",
        label: "Compliance",
        pagename: "ComplianceConfiguration",
        children: [],
        child: [],
      },
      {
        id: "37",
        label: "Status Table",
        pagename: "StatusTable",
        children: [],
        child: [],
      },
      {
        id: "38",
        label: "Overview",
        pagename: "OverviewHomePage",
        children: [],
        child: [],
      },
    ],
  },
  {
    id: "7",
    label: "Gateway",
    pagename: "Gateways",
    children: [],
    child: [
      {
        id: "700",
        label: "Gateway",
        pagename: "Gateways",
        children: [],
        child: [],
      },
    ],
  },
  {
    id: "8",
    label: "Device",
    pagename: "Devices",
    children: [],
    child: [
      {
        id: "800",
        label: "Device",
        pagename: "Devices",
        children: [],
        child: [],
      },
      {
        id: "801",
        label: "Device Library",
        pagename: "DeviceLibrary",
        children: [],
        child: [],
      },
      {
        id: "802",
        label: "Device Types",
        pagename: "DeviceTypes",
        children: [],
        child: [],
      },
    ],
  },
  {
    id: "40",
    label: "Storage",
    pagename: "Storage",
    children: [],
    child: [
      {
        id: "400",
        label: "Storage Groups",
        pagename: "Storage",
        children: [],
        child: [],
      },
      {
        id: "401",
        label: "Storage Period",
        pagename: "StoragePeriod",
        children: [],
        child: [],
      },
    ],
  },
  // {
  //   id: "19",
  //   label: "Asset",
  //   pagename: "Assets",
  //   children: [],
  //   child: [],
  // },
  {
    id: "9",
    label: "Notification",
    pagename: "Notification",
    children: [],
    child: [],
  },
  {
    id: "10",
    label: "User Management",
    pagename: "UserManagement",
    children: [],
    child: [],
  },
  {
    id: "17",
    label: "Plant View",
    pagename: "Plantviewcreation",
    children: [],
    child: [],
  },
  {
    id: "39",
    label: "DashboardConfig",
    pagename: "DbrdConfiguration",
    children: [],
    child: [],
  },
  {
    id: "32",
    label: "OverviewConfig",
    pagename: "OverviewConfig",
    children: [],
    child: [],
  },
  {
    id: "33",
    label: "Audit Log",
    pagename: "AuditConfig",
    children: [],
    child: [],
  },
  {
    id: "36",
    label: "Commission Integration",
    pagename: "CommissionIntegration",
    children: [],
    child: [],
  },
  {
    id: "34",
    label: "Map",
    pagename: "Map",
    children: [],
    child: [],
  },
  {
    id: "35",
    label: "Elogbook",
    pagename: "Elogbook",
    children: [],
    child: [],
  },
];

export default ConfigTreejson;
